import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputDataConfirmationsMutationType } from '../schema/types';

const patchOutputDataConfirmations = (
  _id: number,
  params: Partial<OutputDataConfirmationsMutationType>,
  headers?: HttpHeaders,
): Promise<void> =>
  apiClient
    .patch<void>(
      expand(OutputDataUrl.OUTPUT_DATA_CONFIRMATIONS_QUERY, params),
      params,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useMutateOutputDataConfirmations = createApiMutationHook(
  ['outputDataConfirmations'],
  getMutationFn(undefined, patchOutputDataConfirmations, undefined),
);
